var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0495 3C16.5908 3 20.3508 6.32678 21 10.6635L18.7624 10.998C18.2757 7.74527 15.4556 5.25 12.0495 5.25C8.3011 5.25 5.26239 8.27208 5.26239 12C5.26239 15.7279 8.3011 18.75 12.0495 18.75V21C7.05162 21 3 16.9706 3 12C3 7.02944 7.05162 3 12.0495 3ZM16.4122 17.1709L17.8671 18.894C17.0083 19.6115 16.0135 20.1733 14.9267 20.5355L14.207 18.4017C15.0221 18.1301 15.7682 17.7089 16.4122 17.1709ZM20.9633 13.5636L18.735 13.172C18.5855 14.0214 18.2763 14.8162 17.8394 15.5246L19.7693 16.6993C20.3517 15.755 20.7639 14.6957 20.9633 13.5636Z",
    fill: "currentColor"
  })));
};

export { SvgLoading as ReactComponent };
export default __webpack_public_path__ + "dd68f34b30b4090fc2db25757a7f0595.svg";